module.exports = __webpack_public_path__ + "img/gereg5.6b329a00.jpg";